export default __webpack_public_path__ + "static/media/benefit_icon_video.63c17afc.svg";